if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        try {
          window.pauseAllMedia();
        } catch (e) {}
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        if (!openedMediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element.getAttribute('data-media-id') !== openedMediaId) {
            element.classList.remove('active');
          }
        });

        const activeMedia =
          this.querySelector(`[data-media-id="${openedMediaId}"]`) || this.querySelector('[data-media-id]');

        if (!activeMedia) return;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.clientWidth) {
          container.scrollLeft = Math.max(0, (activeMedia.clientWidth - container.clientWidth) / 2);
        }

        this.loadAndPlayActiveMedia(activeMedia);
      }

      loadAndPlayActiveMedia(activeMedia) {
        if (!activeMedia) return;

        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && typeof activeMedia.loadContent === 'function') {
          try {
            activeMedia.loadContent(false);
          } catch (e) {
            try {
              activeMedia.loadContent();
            } catch (e2) {}
          }
        }

        window.setTimeout(() => {
          try {
            const video = activeMedia.querySelector('video');

            if (video) {
              video.muted = true;
              video.defaultMuted = true;
              video.playsInline = true;
              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');
              video.setAttribute('webkit-playsinline', '');

              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            }
          } catch (e) {}
        }, 160);
      }
    }
  );
}